import { render, staticRenderFns } from "./pdf-icon.vue?vue&type=template&id=3a542559"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a542559')) {
      api.createRecord('3a542559', component.options)
    } else {
      api.reload('3a542559', component.options)
    }
    module.hot.accept("./pdf-icon.vue?vue&type=template&id=3a542559", function () {
      api.rerender('3a542559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/pdf-icon.vue"
export default component.exports